import { render, staticRenderFns } from "./adduserform.vue?vue&type=template&id=5db328ca&scoped=true&"
import script from "./adduserform.vue?vue&type=script&lang=js&"
export * from "./adduserform.vue?vue&type=script&lang=js&"
import style0 from "./adduserform.vue?vue&type=style&index=0&id=5db328ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db328ca",
  null
  
)

export default component.exports